import { m, medium } from 'loren';

import decoded from 'decoded';

export const productsCards = {
    23: { id: 23, section: 'products', icon: 'home', title: '', description: '', media: '', link: '/' },
    25: { id: 25, section: 'products' },
    26: { id: 26, section: 'products' },
    27: { id: 27, section: 'products' },
    28: { id: 28, section: 'products' },
    29: { id: 29, section: 'products' },
    30: { id: 30, section: 'products' },
    31: { id: 31, section: 'products' },
    32: { id: 32, section: 'products' },
    33: { id: 33, section: 'products' }
}



// WEBPACK FOOTER //
// ./app/pages/products.js